import React, { useRef, useState, useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { ICON_SAVE, ICON_CANCEL } from '../../extras/icons';
//Redux
import { useDispatch, useSelector } from 'react-redux';
import { saveRoomsAction, updateRoomsAction } from '../../../actions/roomsActions';
import { listOfijusAction } from '../../../actions/ofijusActions';
import { Formik } from 'formik';
import ButtonSpinner from '../../layout/ButtonSpinner';
import * as yup from 'yup';
import { setLocale } from 'yup';
import recordSystems from '../../../data/recordSystems';
//Función principal
const RoomForm = props => {
    //Tomo los props
    const { show, handleClose } = props;
    //Genero los refs
    const refDescription = useRef();
    //Datos iniciales
    const initialData = {
        descripcion: '',
        domicilio: '',
        ubicacion: '',
        sistema: '',
        ofiju: ''
    }
    //Inicializo el dispatch
    const dispatch = useDispatch();
    //Traigo el store de persona tipos
    const roomsLoading = useSelector( state => state.rooms.loadingSave );
    const errorSave = useSelector( state => state.rooms.errorSave );
    const isEdit = useSelector( state => state.rooms.isEdit );
    const roomSelected = useSelector( state => state.rooms.roomSelected );
    const ofijus = useSelector( state => state.ofijus.ofijus );
    //Inicializo el state local
    const [ room, setRoom ] = useState(initialData);
    //Modifico según el cambio
    useEffect(() => {
        //Me fijo si es edición
        if(isEdit && roomSelected){
            setRoom({
                ...roomSelected,
                sistema: roomSelected.sistema ? roomSelected.sistema.id : '',
                ofiju: roomSelected.ofiju ? roomSelected.ofiju.id : ''
            });
        }else{
            setRoom(initialData);
        }
    }, [isEdit, roomSelected, show])
    //Manejo de cambios
    const handleChange = e => {
        setRoom({
            ...room,
            [e.target.name]: e.target.value
        })
    }
    //Manejo el guardado
    const handleSave = values => {
        //Armo el objeto de datos
        let data = {
            descripcion: values.descripcion,
            domicilio: values.domicilio,
            ubicacion: values.ubicacion,
            invenietid: values.invenietid,
            activo: values.activo,
            ofiju: {
                id: values.ofiju
            },
            sistema: {
                id: values.sistema
            },
            activo: 1
        }
        //Verifico si es edición o alta
        if(room.id){
            //Agrego el ID a la data
            data = {
                id: room.id,
                ...data
            }
            //Es edición
            dispatch( updateRoomsAction(data, handleCloseForm) );
        }else{
            //Es creación
            dispatch( saveRoomsAction(data, handleCloseForm) );
        }
    }
    //Manejo cuando se muestra
    const handleOnShow = e => {
        //Me fijo si cargo ofijus
        dispatch( listOfijusAction({
            search: 'activo:1',
            sort: 'nombre:asc'
        }) );
        //Pongo el foco en el primer campo
        refDescription.current.focus();
    }
    //Manejo cierre de la ventana
    const handleCloseForm = e => {
        //Reinicio datos
        setRoom(initialData);
        //Cierro
        handleClose();
    }
    //Esquema de validación
    const validationSchema = yup.object({
        descripcion: yup.string().required(),
        domicilio: yup.string().required(),
        ubicacion: yup.string().nullable(),
        sistema: yup.number().required(),
        ofiju: yup.number().required()
    });
    //Renderizo
    return (
        <Modal show={show} onHide={handleCloseForm} onShow={handleOnShow} aria-labelledby="contained-modal-title-vcenter" centered>
            <Modal.Header closeButton>
                <Modal.Title>
                    Sala&nbsp;
                    <small><strong>{ isEdit ? 'Editar' : 'Nuevo' } Registro</strong></small>
                </Modal.Title>
            </Modal.Header>
            <Formik
                enableReinitialize
                validationSchema={validationSchema}
                initialValues={{ ...room }}
                onSubmit={ values => handleSave(values) }
            >
                {({
                    handleSubmit,
                    handleChange,
                    handleBlur,
                    values,
                    touched,
                    isValid,
                    errors,
                    isSubmitting
                }) => (
                    <form noValidate onSubmit={handleSubmit} autoComplete="off">
                        <Modal.Body>
                            <div className="row">
                                <Form.Group className="col-md-12">
                                    <label htmlFor="descripcion">Descripción</label>
                                    <Form.Control
                                        id="descripcion"
                                        className="form-control" 
                                        autoFocus 
                                        name="descripcion" 
                                        type="text" 
                                        value={ values.descripcion }
                                        onChange={handleChange}
                                        ref={refDescription}
                                        isInvalid={!!errors.descripcion}
                                        disabled={ roomsLoading }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { errors.descripcion }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-md-12">
                                    <label htmlFor="domicilio">Domicilio</label>
                                    <Form.Control
                                        id="domicilio"
                                        className="form-control" 
                                        name="domicilio" 
                                        type="text" 
                                        value={ values.domicilio }
                                        onChange={handleChange}
                                        isInvalid={!!errors.domicilio}
                                        disabled={ roomsLoading }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { errors.domicilio }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-md-12">
                                    <label htmlFor="ubicacion">Ubicación</label>
                                    <Form.Control
                                        id="ubicacion"
                                        className="form-control" 
                                        name="ubicacion" 
                                        type="text" 
                                        value={ values.ubicacion }
                                        onChange={handleChange}
                                        isInvalid={!!errors.ubicacion}
                                        disabled={ roomsLoading }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { errors.ubicacion }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-md-6">
                                    <label htmlFor="sistema">Sistema</label>
                                    <Form.Control
                                        as="select"
                                        id="sistema"
                                        className="form-control"  
                                        name="sistema" 
                                        value={ values.sistema }
                                        onChange={handleChange}
                                        isInvalid={!!errors.sistema}
                                        disabled={ roomsLoading }
                                    >
                                        <option value="">Seleccione el Sistema</option>
                                        {
                                            recordSystems.map(recordSystem => (
                                                <option value={recordSystem.id} key={`rsg${recordSystem.id}`}>
                                                    { recordSystem.descripcion }
                                                </option>
                                            ))
                                        }
                                    </Form.Control>
                                    <Form.Control.Feedback type="invalid">
                                        { errors.sistema }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-md-6">
                                    <label htmlFor="ofiju">Ofiju</label>
                                    <Form.Control
                                        as="select"
                                        id="ofiju"
                                        className="form-control"  
                                        name="ofiju"  
                                        value={ values.ofiju }
                                        onChange={handleChange}
                                        isInvalid={!!errors.ofiju}
                                        disabled={ roomsLoading }
                                    >
                                        <option value="">Seleccione Ofiju</option>
                                        {
                                            ofijus ? (
                                                ofijus.map(ofiju => (
                                                    <option value={ofiju.id} key={`ro${ofiju.id}`}>
                                                        { ofiju.nombre }
                                                    </option>
                                                ))
                                            ) : null
                                        }
                                    </Form.Control>
                                    <Form.Control.Feedback type="invalid">
                                        { errors.ofiju }
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            {
                                roomsLoading ? (
                                    <ButtonSpinner />
                                ) : (
                                    <Button variant="success" type="submit" disabled={ roomsLoading }>
                                        <ICON_SAVE /> <strong>{ isEdit ? 'ACTUALIZAR' : 'GUARDAR' }</strong>
                                    </Button>
                                )
                            }
                            <Button variant="secondary" onClick={handleCloseForm} disabled={ roomsLoading }>
                                <ICON_CANCEL /> Cancelar
                            </Button>
                        </Modal.Footer>
                    </form>
                )}
            </Formik>
        </Modal>
    );
};

export default RoomForm;